import {
  APPROVEORREJECTMANUALUPGRADEKYC_SUCCESS,
  APPROVEORREJECTMANUALUPGRADEKYC_FAILED,
  RESET_APPROVEORREJECTMANUALUPGRADEKYC,
  LOADING_APPROVEORREJECTMANUALUPGRADEKYC,
  NETWORK_ERROR_APPROVEORREJECTMANUALUPGRADEKYC,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetapproveOrRejectManualUpgradeKYCList = () => {
  return { type: RESET_APPROVEORREJECTMANUALUPGRADEKYC };
};

const approveOrRejectManualUpgradeKYC =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_APPROVEORREJECTMANUALUPGRADEKYC });
    await partnerServices
      .post(
        "approveOrRejectManualUpgradeKYC", userData, { headers: { AuthToken: authTokenIs } }
      )
      .then((res) => {
        switch (res.data.status) {
          case "Success":
            dispatch(approveOrRejectManualUpgradeKYCsuccess(res.data));
            break;
          default:
            dispatch(approveOrRejectManualUpgradeKYCFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_APPROVEORREJECTMANUALUPGRADEKYC,
          payload: err,
        });
      });
  };
function approveOrRejectManualUpgradeKYCsuccess(data) {
  return {
    type: APPROVEORREJECTMANUALUPGRADEKYC_SUCCESS,
    payload: data,
  };
}
function approveOrRejectManualUpgradeKYCFailed(data) {
  return {
    type: APPROVEORREJECTMANUALUPGRADEKYC_FAILED,
    payload: data,
  };
}

export {
  resetapproveOrRejectManualUpgradeKYCList,
  approveOrRejectManualUpgradeKYC,
};
